<template>
	<Row class="flex-align-center icons-preview-container width-100 px-1">
		<Row class="flex-align-center" :key="i" v-for="(icon, i) in iconsToShowInBar">
			<NotificationIconButton v-on="$listeners" class="marg-right" :icon="icon" :isSelected="selectedIcon === icon.name" />
			<Col class="marg-right divider" v-if="i === 0" />
		</Row>
		<Row class="flex-align-center more-button-container">
			<Col class="divider" />
			<NotificationIconsMenu :selectedIcon="selectedIcon" :icons="icons" v-on="$listeners" />
		</Row>
	</Row>
</template>
<script>
import NotificationIconsMenu from '@/components/BlockEditorNotification/CustomizeTabs/CustomizeNotificationMdiIcon/NotificationIcons/NotificationIconsMenu.vue';
import NotificationIconButton from '@/components/BlockEditorNotification/CustomizeTabs/CustomizeNotificationMdiIcon/NotificationIcons/NotificationIconButton.vue';
export default {
	name: 'NotificationIconsBar',
	props: {
		selectedIcon: { type: String },
		icons: { type: Array, default: () => [] },
	},
	components: { NotificationIconsMenu, NotificationIconButton },
	computed: {
		iconsToShowInBar() {
			return [...this.icons].sort((a, b) => {
				if (a.name === this.selectedIcon) return -1;
				if (b.name === this.selectedIcon) return 1;
				return 0;
			});
		},
	},
};
</script>
<style scoped lang="scss">
.marg-right {
	margin-right: 5px;
}
.icons-preview-container {
	height: 35px;
	overflow: hidden;
	width: fit-content;
	border-radius: 8px;
	white-space: nowrap;
	width: calc(100% - 45px);
	border: 1px solid #e7eaf3;
}
.divider {
	width: 1px;
	height: 25px;
	background: #dcdfe6;
}
.more-button-container {
	z-index: 2 !important;
	right: 45px !important;
	position: absolute !important;
}
</style>
